var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"hiq-event-archive__events"},_vm._l((_vm.hits),function(item,index){return _c('Puff',{key:index,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }